/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ format: NonNullable<unknown> }} Drastic_Tech_Exporting_File_LogInputs */



/**
* | output |
* | --- |
* | "Exporting {format} file..." |
*
* @param {Drastic_Tech_Exporting_File_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_exporting_file_log = /** @type {((inputs: Drastic_Tech_Exporting_File_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Exporting_File_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Exportation du fichier ${i?.format}...`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Exportiere die Datei ${i?.format}...`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione del file ${i?.format}...`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт файла ${i?.format}...`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Exportando archivo ${i?.format}...`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在导出${i?.format}文件...`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.format} ファイルをエクスポートしています...`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.format} फ़ाइल निर्यात की जा रही है...`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Exportando o arquivo ${i?.format}...`)
	return /** @type {LocalizedString} */ (`Exporting ${i?.format} file...`)
});